import { VariableItem } from "../VariablesButton";

export enum Variables {
    ARRIVAL = "arrival",
    ARRIVAL_DATE = "arrival_date",
    COMPANY = "company",
    COMPANY_EMAIL = "company_email",
    COMMUNICATION_EMAIL = "company_communication_email",
    COMPANY_PHONE = "company_phone",
    COMPANY_WEBSITE = "company_website",
    CUSTOMER_NAME = "customer_name",
    LISTING_NAME = "listing_name",
    QUANTITY_COUNT = "quantity_count",
    QUANTITY_COUNT_PPL = "quantity_count_people",
    RESUME_BUTTON = "resume_button",
    RESUME_LINK = "resume_link",
    PURCHSABALE_UNIT = "purchasable_unit",
}

export interface VariableModel {
    pattern: RegExp; // used for recognition variables in html given by backend
    title: string; // variable name that is shown in Quill
    name: string; // name of a variable for inner purpose
    variableNode: (document: Document) => Node | string;
}

export const variableModels: { [K in Variables]: VariableModel } = {
    [Variables.ARRIVAL]: {
        pattern: /{{\s?purchase\.items\[0]\.arrivalDate\s?}}/gm,
        title: "Arrival (e.g. 2020-1-31)",
        name: Variables.ARRIVAL,
        variableNode: () => "{{purchase.items[0].arrivalDate}}",
    },
    [Variables.ARRIVAL_DATE]: {
        pattern: /{{\s?purchase\.items\[0]\.arrivalDate\|date\('F\sj,\sY'\)\s?}}/gm,
        title: "Arrival (e.g. January 31, 2020)",
        name: Variables.ARRIVAL_DATE,
        variableNode: () => "{{purchase.items[0].arrivalDate|date('F j, Y')}}",
    },
    [Variables.COMPANY]: {
        pattern: /{{\s?seller\.name\s?}}/gm,
        title: "Company name",
        name: Variables.COMPANY,
        variableNode: () => "{{seller.name}}",
    },
    [Variables.COMPANY_EMAIL]: {
        pattern: /{{\s?seller\.email\s?}}/gm,
        title: "Company email",
        name: Variables.COMPANY_EMAIL,
        variableNode: () => "{{seller.email}}",
    },
    [Variables.COMMUNICATION_EMAIL]: {
        pattern: /{{\s?seller\.communicationEmail\s?}}/gm,
        title: "Company communication",
        name: Variables.COMMUNICATION_EMAIL,
        variableNode: () => "{{seller.communicationEmail}}",
    },
    [Variables.COMPANY_PHONE]: {
        pattern: /{{\s?seller\.phone\s?}}/gm,
        title: "Company phone",
        name: Variables.COMPANY_PHONE,
        variableNode: () => "{{seller.phone}}",
    },
    [Variables.COMPANY_WEBSITE]: {
        pattern: /{{\s?seller\.website\s?}}/gm,
        title: "Company website",
        name: Variables.COMPANY_WEBSITE,
        variableNode: () => "{{seller.website}}",
    },
    [Variables.CUSTOMER_NAME]: {
        pattern: /{{\s?purchase\.customerName\|first_name\s?}}/gm,
        title: "Customer name",
        name: Variables.CUSTOMER_NAME,
        variableNode: () => "{{purchase.customerName|first_name}}",
    },
    [Variables.LISTING_NAME]: {
        pattern: /{{\s?purchase\.items\[0]\.product\.name\s?}}/gm,
        title: "Product name",
        name: Variables.LISTING_NAME,
        variableNode: () => "{{purchase.items[0].product.name}}",
    },
    [Variables.QUANTITY_COUNT]: {
        pattern: /{{\s?purchase\.items\[0]\.quantity\s?}}/gm,
        title: "Quantity Count (e.g. 2)",
        name: Variables.QUANTITY_COUNT,
        variableNode: () => "{{purchase.items[0].quantity}}",
    },
    [Variables.PURCHSABALE_UNIT]: {
        pattern: /{{\s?'EMAIL\.ABANDON\.PEOPLE'\|transchoice\(2\)\|split\('\s'\)\|last\s?}}/gm,
        title: "Purchasable Unit (e.g. unit, people)",
        name: Variables.PURCHSABALE_UNIT,
        variableNode: () => "{{'EMAIL.ABANDON.PEOPLE'|transchoice(2)|split(' ')|last}}",
    },
    [Variables.QUANTITY_COUNT_PPL]: {
        pattern: /{{\s?'EMAIL\.ABANDON\.PEOPLE'\|transchoice\(purchase\.items\[0]\.quantity\)\s?}}/gm,
        title: "Quantity (e.g. 2 people)",
        name: Variables.QUANTITY_COUNT_PPL,
        variableNode: () => "{{'EMAIL.ABANDON.PEOPLE'|transchoice(purchase.items[0].quantity)}}",
    },
    [Variables.RESUME_BUTTON]: {
        pattern: /<a style[^>]*href=["'][^"']*{{\s*(?:xola_checkout_url|resumeUrl)\s*}}[^"']*["'][^>]*>.*?<\/a>/gm,
        title: "Resume button",
        name: Variables.RESUME_BUTTON,
        variableNode: (document) => {
            const anchor = document.createElement("a");
            anchor.setAttribute(
                "style",
                "color:#ffffff;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;text-decoration:none;text-transform: uppercase;background-color:#8bc440;padding:15px 50px;width: 150px;display: inline-block;",
            );
            anchor.setAttribute("href", "{{ website }}{{ resumeUrl }}");
            anchor.setAttribute("target", "_blank");
            anchor.textContent = "Resume Booking";
            return anchor;
        },
    },
    [Variables.RESUME_LINK]: {
        pattern: /<a (?!style)[^>]*href=["'][^"']*{{\s*(?:xola_checkout_url|resumeUrl)\s*}}[^"']*["'][^>]*>.*?<\/a>/gm,
        title: "Resume link",
        name: Variables.RESUME_LINK,
        variableNode: (document) => {
            const anchor = document.createElement("a");
            anchor.setAttribute("href", "{{ website }}{{ resumeUrl }}");
            anchor.setAttribute("target", "_blank");
            anchor.textContent = "Resume Booking";
            return anchor;
        },
    },
};

export const variableItems: VariableItem[] = Object.values(variableModels).map((model) => ({
    title: model.title,
    name: model.name,
    type: "String",
}));

export const EmailVariables = new Set<Variables>([
    Variables.ARRIVAL,
    Variables.ARRIVAL_DATE,
    Variables.COMPANY,
    Variables.COMPANY_EMAIL,
    Variables.COMMUNICATION_EMAIL,
    Variables.COMPANY_PHONE,
    Variables.COMPANY_WEBSITE,
    Variables.CUSTOMER_NAME,
    Variables.LISTING_NAME,
    Variables.QUANTITY_COUNT,
    Variables.QUANTITY_COUNT_PPL,
    Variables.PURCHSABALE_UNIT,
]);
